import {rgElement} from '../rgElement/rg-element.js';

function waitForApi(args, fn) {
    this.addEventListener('rg-map:apiready', function () {
        if (typeof this[fn] === 'function') {
            this[fn](...args);
        }
    }.bind(this), {
        once: true,
        passive: true
    });
}

export class rgMap extends rgElement {

    lat = null;
    lon = null;
    center = null;
    zoom = 14;
    maxzoom = null;
    usecluster = false;
    location = '';
    map = null;
    apiReady = false;
    mapReady = false;
    config = new Map([
        ['baseLayer', ''],
        ['layers', []],
        ['ApiKeys', new Map()],
        ['displayProjection', 'EPSG:900913'],
        ['nominatimUrl', 'https://photon.komoot.io/api/?lang=de&q='],
        ['lastLocation', ''],
    ]);
    status = new Map([
        ['manipulatingAttributes', false],
    ]);
    /**Layers**/
    layers = new Map();
    features = new Map();

    static observedAttributes = [
        'data-zoom',
        'data-lat',
        'data-lon',
        'data-center',
        'data-location',
    ];

    constructor() {
        super();
    }

    connectedCallback() {
        this.setUpElement();
        this.attachShadow({mode: 'open'});
        this.loadCss(this.rootpath + '/css/rg-map.css');
        this.addEventListener('rg-map:apiloaded', function () {
            rgMapApi.assignTo(this);
            this.dispatchEvent(new CustomEvent(this.tagName.toLowerCase() + ':apiready', {
                detail: {el: this}
            }));
            this.setup();
        }.bind(this));
        this.extendApi('/api/rg-map-api.js');
        this.setupComplete();
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.status.get('manipulatingAttributes') && this.map && newValue) {
            if (name === 'data-center') {
                this.lat = null;
                this.lon = null;
            }
            this.setAttributes();
        }
    }

    setAttributes() {
        waitForApi.call(this, arguments, 'setAttributes');
    }

    addDataLayer() {
        waitForApi.call(this, arguments, 'addDataLayer');
    }

    zoomToMaxExtent() {
        waitForApi.call(this, arguments, 'zoomToMaxExtent');
    }

    zoomToLayerExtent() {
        waitForApi.call(this, arguments, 'zoomToLayerExtent');
    }

    getDataLayer() {
        waitForApi.call(this, arguments, 'getDataLayer');
    }

    showLocation() {
        waitForApi.call(this, arguments, 'showLocation');
    }
}